import { FC, SyntheticEvent } from 'react';
import styled from 'styled-components';
import { Tab, Tabs } from '@mui/material';
import {
  chatActions,
  chatSelectors,
  ChatType,
  useAppDispatch,
  useAppSelector,
} from '@vs-online-only-app/state';

const StyledTabs = styled(Tabs)`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;

type Props = {
  activeConversationsCount?: number;
  archivedConversationsCount?: number;
};

export const ConversationTypeMenuTab: FC<Props> = ({
  activeConversationsCount,
  archivedConversationsCount,
}) => {
  const dispatch = useAppDispatch();
  const selectedChatType = useAppSelector(chatSelectors.selectSelectedChatType);

  const handleChange = (_: SyntheticEvent, newValue: string) => {
    dispatch(chatActions.setSelectedChatType(newValue as ChatType));
  };

  return (
    <StyledTabs value={selectedChatType} onChange={handleChange}>
      <Tab label={`Active (${activeConversationsCount})`} value="active" />
      <Tab
        label={`Archived (${archivedConversationsCount})`}
        value="archived"
      />
    </StyledTabs>
  );
};
